import { Pipe, PipeTransform } from "@angular/core";

import { EntryResult, ObjectResult } from "src/core/backend/controllers";

export interface ItemQueryParams {
  page?: number;
  search?: string;
}

export interface ItemLink {
  title: string;
  routerLink: string[];
  queryParams: ItemQueryParams;
}

@Pipe({ name: "itemLink", pure: true, standalone: true })
export class ItemLinkPipe implements PipeTransform {
  transform(item: EntryResult, searchString?: string | null): ItemLink {
    const routerLink = ["/library", item.id];
    const queryParams: ItemQueryParams = {};
    if (item.page != null) queryParams.page = item.page;
    if (searchString) queryParams.search = searchString;
    return { routerLink, queryParams, title: item.title };
  }
}

@Pipe({ name: "objectLink", pure: true, standalone: true })
export class ObjectLinkPipe implements PipeTransform {
  transform(objRes: ObjectResult, docRes?: EntryResult, search?: string | null): ItemLink | undefined {
    if (!docRes) return;
    const routerLink = ["/library", docRes.id];
    const queryParams: ItemQueryParams = {};
    const page = objRes.logicalPageNumber ?? docRes.page;
    if (page != null) queryParams.page = page;
    if (search) queryParams.search = search;
    return { routerLink, queryParams, title: objRes.chapterName ?? docRes.title };
  }
}
